/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import { createRelayResource } from '../../controllers/relay-utils';
import HubBootstrapQuery from '../../ui/hub-bootstrap/__generated__/hubBootstrapQuery.graphql';
export var hubBootstrapResource = createRelayResource({
  getQuery: function getQuery(_, _ref) {
    var cloudId = _ref.cloudId,
      helpCenterAri = _ref.helpCenterAri;
    return {
      variables: {
        cloudId: cloudId,
        hubAri: helpCenterAri
      },
      query: HubBootstrapQuery,
      options: {
        fetchPolicy: 'store-or-network'
      }
    };
  }
});